"use strict";

import throttle from "lodash/throttle";
import helper from "./helper.js";
import Scrollama from "scrollama";
import imagesLoaded from "imagesloaded";

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const Global = {
  testimonials: function () {
    // set each logo size based on if it is horizontal or vertical
    document.querySelectorAll(".testimonial .logo").forEach((logo) => {
      const logoImg = logo.querySelector("img");
      if (logoImg) {
        if (logoImg.offsetWidth > logoImg.offsetHeight) {
          logoImg.style.width = "8rem";
          logoImg.style.height = "auto";
        } else {
          logoImg.style.width = "auto";
          logoImg.style.height = "4rem";
        }
      }
    });
  },

  // this prevents a somewhat common website hack
  add_noopener: function () {
    document.querySelectorAll('a[target="_blank"]').forEach((link) => {
      link.setAttribute("rel", "noopener");
    });
  },

  page_nav: function () {
    document.querySelectorAll(".page-nav a").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const target = document.querySelector(link.getAttribute("href"));

        if (!target) {
          return;
        }

        this.scroll_to(target.getBoundingClientRect().top + window.pageYOffset);
      });
    });
  },

  scroll_to: function (target) {
    var distance = Math.abs(window.pageYOffset - target);
    var duration = 1000;
    var start_time = null;

    function step(timestamp) {
      if (!start_time) start_time = timestamp;
      var progress = timestamp - start_time;
      var percentage = Math.min(progress / duration, 1);
      window.scrollTo(0, window.pageYOffset + (target - window.pageYOffset) * percentage);
      if (progress < duration) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  },

  jump_to_top: function () {
    var jumpBtn = document.querySelector(".jump-to-top");
    jumpBtn.addEventListener('click', function (e) {
      e.preventDefault();
      Global.scroll_to(0);
    });

    window.addEventListener('scroll', throttle(function () {
      var fixedBtn = document.querySelector(".fixed-jump-to-top");
      if (window.pageYOffset > window.innerHeight) {
        fixedBtn.classList.add("active");
      } else {
        fixedBtn.classList.remove("active");
      }
    }, 100));
  },

  cookie_warning: function () {
    var cookieWarning = document.createElement("aside");
    cookieWarning.className = "cookie-warning";
    cookieWarning.innerHTML =
      '<p class="message">This website uses cookies to ensure that you get the best experience on our website.</p><button class="close">Got it</button><br><a href="https://cookiesandyou.com/" target="_blank">Learn More</a>';
    var closeBtn = cookieWarning.querySelector(".close");
    closeBtn.addEventListener("click", function () {
      setCookie("approve-cookies", "true", { expires: 365 });
      cookieWarning.classList.add("hide");
    });

    var approveCookies = getCookie("approve-cookies");
    if (!approveCookies) {
      document.body.appendChild(cookieWarning);
    }
  },

  check_for_tab: function () {
    document.body.addEventListener("keydown", function (e) {
      if (e.keyCode === 9) {
        document.body.classList.add("outlines");
      }
    });
  },

  hamburgers: function () {
    var hamburger = document.querySelector(".hamburger");
    var siteMenu = document.querySelector("nav.site-menu");
    var mainNav = document.querySelector("nav.main-nav");
    var wordmark = document.querySelector("nav.main-nav .wordmark");

    if (!hamburger || !siteMenu) {
      return;
    }

    function syncMenuAlignment() {
      var list = siteMenu.querySelector(".site-menu__list");

      if (!wordmark || !list || window.innerWidth < 800) {
        document.documentElement.style.removeProperty("--site-menu-offset");
        if (list) {
          list.style.marginLeft = "";
        }
        return;
      }

      var left = Math.round(wordmark.getBoundingClientRect().left);
      document.documentElement.style.setProperty("--site-menu-offset", left + "px");
      // Inline style wins over any competing stylesheet margin reset
      list.style.marginLeft = left + "px";
    }

    function setMenuOpen(isOpen) {
      hamburger.classList.toggle("is-active", isOpen);
      siteMenu.classList.toggle("active", isOpen);
      if (mainNav) {
        mainNav.classList.toggle("is-menu-open", isOpen);
      }

      // Lock page scroll; compensate so hiding the scrollbar doesn't shift layout
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.setProperty(
        "--scrollbar-compensation",
        isOpen && scrollbarWidth > 0 ? scrollbarWidth + "px" : "0px"
      );
      document.body.classList.toggle("no-scroll", isOpen);

      if (isOpen) {
        syncMenuAlignment();
      }

      hamburger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      hamburger.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
      siteMenu.setAttribute("aria-hidden", isOpen ? "false" : "true");
    }

    function toggleMenu() {
      setMenuOpen(!hamburger.classList.contains("is-active"));
    }

    hamburger.addEventListener("click", toggleMenu);

    hamburger.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleMenu();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && hamburger.classList.contains("is-active")) {
        setMenuOpen(false);
      }
    });

    window.addEventListener("resize", function () {
      if (hamburger.classList.contains("is-active")) {
        syncMenuAlignment();
      }
    });
  },

  featured_projects: function () {
    var scroller = Scrollama();

    class FeaturedProject {
      constructor(element) {
        this.el = element;
        this.meta = this.el.querySelector(".project-metadata");
        this.picture = this.el.querySelector(".left");
        this.meta_height = this.meta.offsetHeight;
        this.safe = true;
        this.listen();
        this.fix_size();
        this.close();
      }

      fix_size() {
        imagesLoaded(this.picture, () => {
          helper.contain(this.picture, this.picture.querySelector("figure img"));
        });
      }

      close() {
        if (this.safe) {
          this.safe = false;
          this.meta.style.height = this.meta_height + "px";
          this.meta.classList.remove("show-content");
          setTimeout(() => {
            this.el.classList.add("active");
            this.safe = true;
          }, 400);
        }
      }

      open() {
        if (this.safe) {
          this.safe = false;
          this.el.classList.remove("active");
          setTimeout(() => {
            this.meta.classList.add("show-content");
            this.meta.style.height = "auto";
            this.meta_height = this.meta.offsetHeight;
            this.safe = true;
          }, 400);
        }
      }

      listen() {
        var self = this;
        this.el.querySelector(".close").addEventListener("click", function () {
          if (self.el.classList.contains("active")) {
            self.open();
          } else {
            self.close();
          }
        });
      }
    }

    function handleStepEnter(args) {
      projects[args.index].open();
    }

    function handleStepExit(args) {
      projects[args.index].close();
    }

    if (document.querySelector(".featured-projects")) {
      var projects = [];
      document.querySelectorAll(".featured-projects").forEach((project) => {
        project.querySelectorAll(".project").forEach((element) => {
          projects.push(new FeaturedProject(element));
        });
      });

      scroller
        .setup({
          step: ".project",
          offset: 0.5,
        })
        .onStepEnter(handleStepEnter)
        .onStepExit(handleStepExit);
    }
  },

  call_to_action: function () {
    class CallToAction {
      constructor(el) {
        this.el = el;
        this.right = this.el.querySelector(".right");
        this.left = this.el.querySelector(".left");
        this.message = this.left.querySelector("span");
        this.init_group = this.el.querySelector(".button-group.init");
        this.construction_group = this.el.querySelector(".button-group.construction");
        this.development_group = this.el.querySelector(".button-group.development");
        this.investments_group = this.el.querySelector(".button-group.investments");
        this.other_group = this.el.querySelector(".button-group.other");
        this.contact_form = this.el.querySelector(".contact-form");
        this.construction_radio = this.contact_form.querySelector("#construction");
        this.development_radio = this.contact_form.querySelector("#development");
        this.investments_radio = this.contact_form.querySelector("#investments");
        this.other_radio = this.contact_form.querySelector("#other");

        // Formie interest field
        this.formie_interest = this.contact_form.querySelector('input[name="fields[interest]"], select[name="fields[interest]"]');

        this.construction = this.el.querySelector('a[href="#construction"]');
        this.development = this.el.querySelector('a[href="#development"]');
        this.investments = this.el.querySelector('a[href="#investments"]');
        this.other = this.el.querySelector('a[href="#other"]');
        this.contacts = this.el.querySelectorAll('a[href="#contact"]');
        this.other_back = this.other_group.querySelector('a[href="#back"]');
        this.construction_back = this.construction_group.querySelector('a[href="#back"]');
        this.development_back = this.development_group.querySelector('a[href="#back"]');
        this.investments_back = this.investments_group.querySelector('a[href="#back"]');

        this.listen();
        if (this.el.nextElementSibling){
          if (this.el.nextElementSibling.classList.contains("arrow-link")) {
            this.el.classList.add("arrow-link-next");
          }
        }
      }

      listen() {
        var self = this;
        
        function show(el) {
          setTimeout(() => {
            self.right.style.height = el.offsetHeight + "px";
            el.classList.remove("hidden");

            // Update old form's radio buttons
            if (el.classList.contains("construction")) {
              self.message.textContent = "How can we help you with construction?";
              self.construction_radio?.setAttribute("checked", "checked");
              self.setFormieInterest("Construction");
            }
            if (el.classList.contains("development")) {
              self.message.textContent = "How can we help you with development?";
              self.development_radio?.setAttribute("checked", "checked");
              self.setFormieInterest("Development");
            }
            if (el.classList.contains("investments")) {
              self.message.textContent = "How can we help you with investments?";
              self.investments_radio?.setAttribute("checked", "checked");
              self.setFormieInterest("Investments");
            }
            if (el.classList.contains("other")) {
              self.message.textContent = "How else can we help you?";
              self.other_radio?.setAttribute("checked", "checked");
              self.setFormieInterest("Other");
            }
            if (el.classList.contains("init")) {
              self.message.textContent = "What can we help you with?";
              self.clearOldFormRadios();
              self.setFormieInterest(""); // Reset if going back to init state
            }
          }, 750);
        }

        function hide(el) {
          el.classList.add("hidden");
        }

        function listener(el, show_el, hide_el) {
          el.addEventListener("click", function (e) {
            const href = el.getAttribute("href");
        
            // Allow normal navigation for external/internal links
            if (href && !href.startsWith("#")) {
              //console.log("✅ Normal link clicked, allowing navigation:", href);
              return;
            }
        
            // Prevent default only for hash links
            e.preventDefault();
            //console.log("⚠️ Intercepted internal navigation:", href);
        
            // If "Contact Us" is clicked, THEN update the Formie field
            if (href === "#contact" && self.selected_interest) {
              //console.log("🚀 Updating Formie interest to:", self.selected_interest);
              const radios = document.querySelectorAll('input[name="fields[interest]"]');
              radios.forEach((radio) => {
                if (radio.value.toLowerCase() === self.selected_interest.toLowerCase()) {
                  radio.checked = true;
                  radio.dispatchEvent(new Event("change", { bubbles: true }));
                } else {
                  radio.checked = false;
                }
              });
            }
        
            // Only show/hide elements if this button is form-related
            if (show_el?.classList.contains("contact-form") || show_el?.classList.contains("button-group")) {
              hide(hide_el);
              show(show_el);
              mainBack(show_el);
            }
          });
        }

        function mainBack(show_el) {
          const main_back = document.querySelector('[data-main-back]');
          if (show_el.classList.contains("contact-form")) {
            main_back.classList.remove("hidden");
          } else {
            main_back.classList.add("hidden");
          }
        
          main_back.addEventListener("click", function (e) {
            e.preventDefault();
            
            //console.log("🔄 Back button clicked. Last selected interest:", self.selected_interest);
        
            // ✅ Reset Formie tracking to prevent "Leave site?" warning
            window.onbeforeunload = null;
        
            // ✅ Clear radio selection (so the form is no longer "dirty")
            const radios = document.querySelectorAll('input[name="fields[interest]"]');
            radios.forEach(radio => radio.checked = false);
        
            // ✅ Navigate back to the correct section
            if (self.selected_interest) {
              if (self.selected_interest.toLowerCase() === "construction") {
                show(self.construction_group);
              } else if (self.selected_interest.toLowerCase() === "development") {
                show(self.development_group);
              } else if (self.selected_interest.toLowerCase() === "investments") {
                show(self.investments_group);
              } else if (self.selected_interest.toLowerCase() === "other") {
                show(self.other_group);
              } else {
                show(self.init_group); // Default back to main options
              }
            } else {
              show(self.init_group); // If no selection, return to main options
            }
        
            hide(self.contact_form); // Hide the contact form
            main_back.classList.add("hidden"); // Hide the back button
          });
        }

        show(this.init_group);
        hide(this.construction_group);
        hide(this.development_group);
        hide(this.investments_group);
        hide(this.other_group);
        hide(this.contact_form);

        listener(this.construction, this.construction_group, this.init_group);
        listener(this.development, this.development_group, this.init_group);
        listener(this.investments, this.investments_group, this.init_group);
        listener(this.other, this.other_group, this.init_group);

        listener(this.construction_back, this.init_group, this.construction_group);
        listener(this.development_back, this.init_group, this.development_group);
        listener(this.investments_back, this.init_group, this.investments_group);
        listener(this.other_back, this.init_group, this.other_group);

        if (this.contacts) {
          Array.from(this.contacts).forEach((contact) => {
            listener(contact, this.contact_form, this.development_group);
            listener(contact, this.contact_form, this.construction_group);
            listener(contact, this.contact_form, this.investments_group);
            listener(contact, this.contact_form, this.other_group);
            listener(contact, this.contact_form, this.init_group);
          });
        }
      }

      setFormieInterest(value) {
        console.log("Storing interest selection:", value);
        this.selected_interest = value; // Store selection in memory, but don’t update Formie yet
    }

      clearOldFormRadios() {
        this.construction_radio?.removeAttribute("checked");
        this.development_radio?.removeAttribute("checked");
        this.investments_radio?.removeAttribute("checked");
        this.other_radio?.removeAttribute("checked");
      }
    }

    document.querySelectorAll(".call-to-action").forEach((cta) => {
      new CallToAction(cta);
    });
  },

  contact_form: function () {
    document.querySelectorAll(".focus-form").forEach(function (subscribeForm) {
      var submitButton = subscribeForm.querySelector("button[type=submit]");

      subscribeForm.addEventListener("submit", function (event) {
        event.preventDefault();

        var endpoint = subscribeForm.getAttribute("action");
        var fd = new FormData(subscribeForm);

        fetch(endpoint, {
          method: "POST",
          body: fd,
          headers: {
            accept: "application/javascript",
          },
        })
          .then(function (response) {
            if (window.dataLayer) window.dataLayer.push({ event: "generate_lead" });
            var message = subscribeForm.querySelector(".message");
            message.style.display = "block";
            if (response.status == 200 || response.status == 304) {
              message.querySelector("div:first-of-type").textContent =
                "Your message was sent successfully";
              message.querySelector("div:last-of-type").textContent = "Thank You!";
              message.classList.remove("failure");
              message.classList.add("success");
              subscribeForm.reset();
            } else {
              message.querySelector("div:first-of-type").textContent =
                "Your message was not sent";
              message.querySelector("div:last-of-type").textContent =
                "Please try again.";
              message.classList.remove("success");
              message.classList.add("failure");
            }
            submitButton.disabled = false;
          })
          .catch(function (error) {
            console.error("Error:", error);
            var message = subscribeForm.querySelector(".message");
            message.style.display = "block";
            message.querySelector("div:first-of-type").textContent =
              "There was an error in the pipeline.";
            message.querySelector("div:last-of-type").textContent =
              "Please try again or contact support!";
            message.classList.remove("success");
            message.classList.add("failure");
            submitButton.disabled = false;
          });

        submitButton.disabled = true;
      });

      var checkbox = subscribeForm.querySelector(
        'input[type="checkbox"][name="requestBid"]'
      );
      var fileInput = subscribeForm.querySelector('input[type="file"]');

      checkbox.addEventListener("change", function () {
        if (checkbox.checked) {
          enableBidForm(subscribeForm, checkbox);
        } else {
          disableBidForm(subscribeForm, checkbox);
        }
      });

      //var pond = FilePond.create(fileInput);
      if (fileInput) {
        fileInput.addEventListener("change", function () {
          if (this.files.length) {
            for (let file of this.files) {
              // Do something with the file(s)
            }
          }
        });
      }

      if (window.location.hash == "#bid") {
        enableBidForm(subscribeForm, checkbox);
      } else {
        disableBidForm(subscribeForm, checkbox);
      }
    });

    function enableBidForm(form, checkbox) {
      checkbox.checked = true;
      form.querySelector('textarea[name="message"]').placeholder =
        "Tell us about your project.";
      form.querySelector('textarea[name="message"]').removeAttribute("required");
      form.querySelector('input[name="subject"]').style.display = "none";
      form.querySelector(".file-field").style.display = "block";
    }

    function disableBidForm(form, checkbox) {
      checkbox.checked = false;
      form.querySelector('textarea[name="message"]').placeholder =
        "Tell us a bit about your idea.*";
      form.querySelector('textarea[name="message"]').setAttribute("required", true);
      form.querySelector('input[name="subject"]').style.display = "block";
      const fileField = form.querySelector(".file-field");
      if (fileField) {
        fileField.style.display = "none";
      }
    }
  },

  interest_form() {
    document.querySelectorAll(".interest-form").forEach((subscribeForm) => {
      var submitButton = subscribeForm.querySelector("button[type=submit]");

      subscribeForm.addEventListener("submit", function (event) {
        event.preventDefault();

        fetch(subscribeForm.getAttribute("action"), {
          method: "POST",
          headers: {
            accept: "application/javascript",
          },
          body: new URLSearchParams(new FormData(subscribeForm)),
        })
          .then(function (response) {
            console.log(response);
            if (window.dataLayer) window.dataLayer.push({ event: "generate_lead" });
            var message = subscribeForm.parentNode.querySelector(".message");
            message.style.display = "block";
            if (response.status == 200 || response.status == 302) {
              message.querySelector("div:first-of-type").textContent =
                "You have been successfully subscribed.";
              message.querySelector("div:last-of-type").textContent = "Thank You!";
              message.classList.add("success");
            } else {
              message.querySelector("div:first-of-type").textContent =
                "There was an error in the pipeline.";
              message.querySelector("div:last-of-type").textContent =
                "Please try again or contact support!";
              message.classList.add("failure");
            }
            subscribeForm.reset();
            submitButton.disabled = false;
          })
          .catch(function (error) {
            console.error("Error:", error);
            var message = subscribeForm.parentNode.querySelector(".message");
            message.style.display = "block";
            message.querySelector("div:first-of-type").textContent =
              "There was an error in the pipeline.";
            message.querySelector("div:last-of-type").textContent =
              "Please try again or contact support!";
            message.classList.add("failure");
            submitButton.disabled = false;
          });

        submitButton.disabled = true;
      });
    });
  },

  init: function () {
    this.jump_to_top();
    this.check_for_tab();
    helper.fix_page_height();
    this.contact_form();
    this.interest_form();
    this.featured_projects();

    this.hamburgers();
    this.call_to_action();
    this.add_noopener();
    this.page_nav();
    this.testimonials();
    this.cookie_warning();

    var approveGeneralMessage = getCookie("approve-general-message");
    if (!approveGeneralMessage) {
      var generalMessage = document.querySelector(".general-message");
      if (generalMessage) {
        generalMessage.style.display = "block";
        generalMessage.querySelector(".close").addEventListener("click", function () {
          setCookie("approve-general-message", "true", { expires: 365 });
          generalMessage.style.display = "none";
        });
      }
    }
    return this;
  },
};

// The following lines should be at the end of your script:
helper.fix_page_height();


export default Global.init();

document.addEventListener("DOMContentLoaded", function () {
  let formieInterestField = document.querySelector('input[name="fields[interests]"], select[name="fields[interests]"]');

  if (!formieInterestField) {
      //console.error("🚨 Formie Interests field not found!");
      return;
  }

  // Listen for user changes and update Formie field
  document.querySelectorAll('input[name="interestOptions"]').forEach(radio => {
      radio.addEventListener("change", function () {
          //console.log("✅ Interest changed to:", this.value);
          formieInterestField.value = this.value;
          formieInterestField.dispatchEvent(new Event("change", { bubbles: true }));
      });
  });
});